import { createFileRoute } from "@tanstack/react-router";
import { TicketReport } from "@/features/tickets/TicketReport";

export const Route = createFileRoute("/_authenticated/reports/vendor-tickets")({
  component: () => (
    <TicketReport
      id="R-49"
      title="Vendor Tickets"
      description="Tickets assigned to an external vendor (warranty / AMC / CMC)."
      enabledFilters={["branch", "vendor", "status", "coverage", "dateRange"]}
      filename="vendor-tickets"
    />
  ),
});
